module.exports = ".app-version {\n    float: right;\n    margin-right: 16px;\n    margin-bottom: 16px;\n    font-size: 1rem;\n    font-weight: bold;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n}\n\n\n.inner-content {\n  /*margin-top: 64px;*/\n  height: calc(100% - 64px);\n  overflow-y: scroll;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main